import { createSimpleButtonToolbarItem } from './simple-button-toolbar-item.factory';
import { ActionIds } from '../actions/action.types';
import { appState } from '../app.state';
import type { CellWidthView } from '../app.state';
import type { TimelineToolbarItem } from '../types/timeline-toolbar-item.interface';

/**
 * The three cell-width buttons of the timeline toolbar (Anke, 2026-10-14), left to right:
 * "Kompakt Ansicht" (0.5), "Standard Ansicht" (1), "Detail Ansicht" (4). Each one dispatches
 * timeline.setCellWidthView with its view; clicking the active one changes nothing.
 *
 * The button of the active view carries the class `active` (styled by buttons.css
 * `button.active`; restyle via e.g. `.timeline-toolbar-start button.active`). The class is read
 * on every render, and the timeline views re-render on every appState change (StateController).
 *
 * Orders 10–12 sit between "Fokus auf Heute" (0) and the project board's sort toggle (15).
 * Icons and two-line labels: `button.<class>` rules — the detail button keeps its old class
 * `toggle-week-view`, whose icon lives in buttons.css and which the e2e page object clicks.
 */
function cellWidthViewToolbarItem(id: string, view: CellWidthView, cssClass: string, labelKey: string, order: number): TimelineToolbarItem {
    return createSimpleButtonToolbarItem({
        id,
        cssClass: () => (appState.cellWidthView() === view ? `${cssClass} active` : cssClass),
        labelKey,
        actionId: ActionIds.TIMELINE_SET_CELL_WIDTH_VIEW,
        actionPayload: view,
        position: 'start',
        order,
    });
}

export const compactViewToolbarItem = cellWidthViewToolbarItem('compact-view', 'compact', 'compact-view', 'toolbar.compactView', 10);

export const standardViewToolbarItem = cellWidthViewToolbarItem('standard-view', 'standard', 'standard-view', 'toolbar.standardView', 11);

export const detailViewToolbarItem = cellWidthViewToolbarItem('detail-view', 'detail', 'toggle-week-view', 'toolbar.toggleWeekView', 12);
